import { Component, OnInit } from "@angular/core";
import { AuthService } from "angularx-social-login";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  SearchCountryField,
  CountryISO
} from "ngx-intl-tel-input";
import {
  FacebookLoginProvider,
  GoogleLoginProvider
} from "angularx-social-login";
import { ToastrService } from "ngx-toastr";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from "@angular/forms";
import { WebappService } from "../../../service/webapp.service";
import { AuthenticationService } from "app/service/authentication.service";
import * as firebaseui from 'firebaseui';
import * as firebase from 'firebase';
import { AngularFireAuth } from '@angular/fire/auth';
import { CredentialResponse } from 'google-one-tap';	
import jwt_decode from "jwt-decode";

@Component({
  selector: "app-signin",
  templateUrl: "./signin.component.html",
  styleUrls: ["./signin.component.scss"]
})
export class SigninComponent implements OnInit {
  jwtResponse: any;
  user: any;
  social_email: any;
  requestData: any;
  loggeddata: object;
  signinForm: FormGroup;
  mobileForm: FormGroup;
  googlesignin: boolean;
  facebooksignin: boolean;
  socialsignin: boolean;
  separateDialCode = true;
  userAuthToken: any;
  UserIsAuthenticated: boolean;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom
  ];
  ui: firebaseui.auth.AuthUI;
  firebaseUiAuthConfig: firebaseui.auth.Config = {
    /* signInFlow: 'popup', */
    signInOptions: [
      {
        provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
        // Invisible reCAPTCHA with image challenge and bottom left badge.
        recaptchaParameters: {
          type: 'image',
          size: 'normal',
          badge: 'bottomleft'
        }
      },
    ],
    callbacks: {
      signInSuccessWithAuthResult: this.mobileVerifiedSucceed.bind(this),
      signInFailure: this.mobileVerifiedFailed.bind(this),
    },

  }
  constructor(
    private socialauthService: AuthService,
    private authService: AuthenticationService,
    private apiservice: WebappService,
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private afAuth: AngularFireAuth,
  ) {
    /*  if (this.authService.loggedIn) {
      this.router.navigate(['/search']);
    } */
    this.UserIsAuthenticated = false;
    this.socialsignin = false;
    this.signinForm = this.fb.group({
      username: [
        "",
        Validators.compose([Validators.required, Validators.email])
      ],
      password: [
        "",
        Validators.compose([Validators.required, Validators.minLength(6)])
      ]
    });

    this.mobileForm = this.fb.group({
      phoneno: ["", Validators.required]
    });
  }

  ngOnInit() {
    this.appConfig();
    this.googlesignin = false;
    this.facebooksignin = false;
    this.socialauthService.authState.subscribe(user => {
      if (user && this.socialsignin) {
        this.social_email = user.email;
        this.toastr.success(this.translate.instant("Social login connected"));
      }
    });
  }

  ngAfterViewInit() {	
    google.accounts.id.initialize({	
      client_id: "645101975805-b5jvp3vltm3pek20uahrniuq6odhh83p.apps.googleusercontent.com",	
      callback: this.handleCredentialResponse.bind(this),	
      auto_select: false,	
      cancel_on_tap_outside: true	
    });	
    google.accounts.id.renderButton(	
      document.getElementById("googleSignIn"),	
      { theme: "filled_blue", size: "large", logo_alignment: "left", width: 400 }	
    );	
    /* google.accounts.id.prompt((notification: PromptMomentNotification) => { }); */	
  }	
  async handleCredentialResponse(response: CredentialResponse) {	
    if (response) {	
      if (response.credential) {	
        this.jwtResponse = jwt_decode(response.credential);	
        this.social_email = this.jwtResponse.email;	
        this.toastr.success(this.translate.instant("Social login connected"));	
      }	
    }	
  }	

  signInWithGoogle(): void {
    this.socialauthService.signIn(GoogleLoginProvider.PROVIDER_ID);
    this.socialsignin = true;
  }

  signInWithFB(): void {
    this.socialauthService.signIn(FacebookLoginProvider.PROVIDER_ID);
    this.socialsignin = true;
  }




  onLoginSubmit(login) {
    if (this.signinForm.valid) {
      const requestData = {
        email: login.username,
        password: login.password,
        role: "user"
      };
      this.apiservice.accountsignin(requestData).subscribe(data => {
        if (data["status"] === "true") {
          if (
            !localStorage.getItem("authtoken") &&
            !localStorage.getItem("user")
          ) {
            this.loggeddata = {
              id: data["user_id"],
              name: data["full_name"],
              email: data["email"],
              role: data["role"],
              ad_unit_id: data["ad_unit_id"],
              admin_enable_ads: data["admin_enable_ads"],
            };
            this.userAuthToken = data["token"];
            this.UserIsAuthenticated = true;
            this.ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(this.afAuth.auth);
            this.ui.start('#firebaseui-auth-container', this.firebaseUiAuthConfig);
          } else {
            this.toastr.error(this.translate.instant("Kindly sign out as admin"));
            window.scrollTo(0, 0);
          }
        } else {
          this.toastr.error(this.translate.instant(data["message"]));
          window.scrollTo(0, 0);
        }
      });
    } else {
      this.validateAllFormFields(this.signinForm);
    }
  }

  mobileVerificationCompleted() {
    this.authService.storeUserData(this.userAuthToken, this.loggeddata);
    /* web-push signin-method */
    if (localStorage.getItem("firebase_auth")) {
      const tokenData = {
        user_id: this.loggeddata["id"],
        device_token: localStorage.getItem("firebase_auth")
      };
      this.apiservice.webSignin(tokenData).subscribe(data => {
      });
    }
    if (
      localStorage.getItem("pickup_location") &&
      localStorage.getItem("drop_location")
    ) {
      this.router.navigate(["/search"]);
    } else {
      this.router.navigate(["/"]);
    }
  }

  mobileVerifiedSucceed(signInSuccessData) {
    if (!signInSuccessData.user.phoneNumber) {
      this.toastr.error(this.translate.instant("Mobile Number Verification Failed"));
      this.router.navigate(["/signin"]);
    } else {
      let requestData = {
        "user_id": this.loggeddata["id"],
        "phoneNumber": signInSuccessData.user.phoneNumber,
      }
      this.apiservice.changephoneno(requestData).subscribe(data => {
        if (data['status'] === 'true') {
          this.mobileVerificationCompleted();
        } else {
          this.toastr.error(this.translate.instant(data['message']));
          this.router.navigate(['/signin']);
        }
      });
    }
  }

  mobileVerifiedFailed(Error) {
    /* console.log("Verification failed" + Error); */
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  appConfig() {
    this.apiservice.appconfig().subscribe(data => {
      if (data["status"] === "true") {
        localStorage.setItem("CS", data["currencysymbol"]);
      }
    });
  }
}
